import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import DesignTokens from "./designTokens"
import logoWhite from "../images/lte-impianti-logo-bianco.svg"
import User from "../components/icons/user"
import PrimaryMenu from "./primaryMenu"

const LargeNav = ({ theme }) => {
  const [color, setColor] = useState(DesignTokens.colors.white)
  return (
    <nav>
      <StyledMenu theme={theme}>
        <Logo theme={theme}>
          <Link to="/">
            <img
              src={logoWhite}
              alt="LTE Impianti Logo"
            />
          </Link>
        </Logo>
        <PrimaryMenu />
        <Icon
          onMouseEnter={() => setColor(DesignTokens.colors.secondary[500])}
          onMouseLeave={() => setColor(DesignTokens.colors.white)}
          href="http://185.184.139.206:8181/#/logon"
          target="blank"
          rel="noopener nofollow"
          theme={theme}
        >
          <User color={color} />
        </Icon>
      </StyledMenu>
    </nav>
  )
}

const Logo = styled.div`
  background: ${props => props.theme === "transparent" ? "transparent" : DesignTokens.colors.primary[500]};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 275px;
`

const Icon = styled.a`
  border-left: 1px solid ${props => props.theme === "transparent" ? "transparent" : DesignTokens.colors.tertiary[100]};
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 70px;
`

const StyledMenu = styled.div`
  z-index: 1;
  position: relative;
  padding: 0;
  display: flex;
  flex-direction: row;
  background: ${props => props.theme === "transparent" ? "transparent" : DesignTokens.colors.primary[500]};

  & > ul {
    height: 80px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    & > li {
      margin: 0;
      text-align: center;
      width: calc(100% / 6);
      /* border-right: 1px solid ${props => props.theme === "transparent" ? "transparent" : DesignTokens.colors.tertiary[100]}; */

      &:last-child {
        border-right: 0;
      }
      & > a {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        font-weight: 900;
        color: ${DesignTokens.colors.white};
        text-decoration: none;
        &:active,
        &:hover {
          color: ${DesignTokens.colors.secondary[500]};
        }
      }
    }
  }
`

export default LargeNav
